import { useParams } from 'react-router-dom'
import { useInvoice } from '@/hooks/useInvoice'
import { InvoiceView } from '@/components/InvoiceView'

export function InvoicePage() {
  const { paymentToken } = useParams<{ paymentToken: string }>()
  const { data, isLoading, error, refetch } = useInvoice(paymentToken)

  // Loading state - clean spinner
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#f9fafb]">
        {/* Spinner */}
        <div className="w-16 h-16 relative mb-6">
          <div className="absolute inset-0 rounded-full border-2 border-[#e5e7eb]" />
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#111827] animate-spin" />
        </div>
        <p className="text-sm text-[#6b7280]">Loading invoice...</p>
      </div>
    )
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#f9fafb] px-4">
        <div className="w-16 h-16 rounded-full bg-[#f3f4f6] flex items-center justify-center mb-6">
          <svg
            className="w-8 h-8 text-[#6b7280]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-[#111827] mb-2">
          {error === 'Invoice not found' ? 'Invoice not found' : 'Something went wrong'}
        </h1>
        <p className="text-sm text-[#6b7280] text-center max-w-xs">
          {error === 'Invoice not found'
            ? 'This invoice doesn\'t exist or the link is invalid.'
            : error}
        </p>
      </div>
    )
  }

  if (!data) {
    return null
  }

  return (
    <InvoiceView
      invoice={data.invoice}
      business={data.business}
      client={data.client}
      payment={data.payment}
      paymentToken={paymentToken!}
      onPaymentSuccess={refetch}
    />
  )
}
